import { Injectable } from '@angular/core';
import { LaunchDarklyService } from '../../../shared/services/launchdarkly.service';
import { AuthService } from '@yotpo-ui/core';
import { ENV } from '../../../environment';
import { Observable } from 'rxjs';

@Injectable()
export class LaunchDarklyResolver {

  constructor(private launchDarklyService: LaunchDarklyService,
              private authService: AuthService) { }

  init() {
    if (ENV.launchDarklyEnabled && ENV.launchDarklyClientId) {
      return this.launchDarklyService.waitUntilReady().then(() =>
        this.launchDarklyService.changeUser(this.authService.getCredentials().appKey).then(() => {
          return {
            flags: {
              ugcPostman: this.launchDarklyService.getFlagStatus('ugc-postman'),
              ugcPostmanDelivery: this.launchDarklyService.getFlagStatus('ugc-postman-delivery')
            }
          };
        })
      );
    } else {
      return Observable.of({
        flags: {
          ugcPostman: false
        }
      });
    }
  }
}
